/* Buscador Robols: panel de búsqueda con resultados al instante. */
(() => {
  if (customElements.get('robols-search')) return;

  // Fotos de las tarjetas: aparecen suaves al terminar de cargar
  const markLoaded = (img) => {
    if (img.complete && img.naturalWidth) img.classList.add('is-loaded');
  };
  document.querySelectorAll('.rs-card__img').forEach(markLoaded);
  document.documentElement.classList.add('rs-js');
  document.addEventListener(
    'load',
    (e) => {
      if (e.target instanceof HTMLImageElement && e.target.classList.contains('rs-card__img')) {
        e.target.classList.add('is-loaded');
      }
    },
    true
  );
  document.addEventListener(
    'error',
    (e) => {
      if (e.target instanceof HTMLImageElement && e.target.classList.contains('rs-card__img')) {
        e.target.classList.add('is-loaded');
      }
    },
    true
  );

  const RECENT_KEY = 'robols:busquedas-recientes';
  const RECENT_MAX = 6;
  const cache = new Map();
  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const readRecent = () => {
    try {
      const list = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
      return Array.isArray(list) ? list.filter((t) => typeof t === 'string' && t.trim()) : [];
    } catch (e) {
      return [];
    }
  };
  const writeRecent = (list) => {
    try {
      localStorage.setItem(RECENT_KEY, JSON.stringify(list));
    } catch (e) {
      /* almacenamiento no disponible: se ignora */
    }
  };

  /* Índice local de nombres: sugerencias desde la primera letra */
  const INDEX_KEY = 'robols:indice-busqueda-v2';
  const SUG_MAX = 6;
  const SIMILAR_MAX = 4;
  const cardCache = new Map();
  let indexPromise = null;

  // Minúsculas y sin acentos, conservando la longitud del texto
  const fold = (text) =>
    Array.from(text)
      .map((c) => c.normalize('NFD')[0].toLowerCase())
      .join('');
  const norm = (text) =>
    fold(text)
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();

  const NOISE = [
    /\(preventa\)/gi,
    /\u00ae/g,
    /\beau de parfum\b/gi,
    /\beau de toilette\b/gi,
    /\bextrait de parfum\b/gi,
    /\bedp\b/gi,
    /\bedt\b/gi,
    /\btester\b/gi,
    /\b\d+\s?ml\b/gi,
  ];

  const cleanName = (title, vendor) => {
    let name = title;
    // Quita la marca completa, o su parte inicial si el título la trae abreviada
    const words = vendor.split(/\s+/).filter(Boolean);
    for (let n = words.length; n >= 1; n -= 1) {
      const piece = words.slice(0, n).join(' ');
      if (n === 1 && piece.length < 4) break;
      const at = fold(name).indexOf(fold(piece));
      if (at >= 0) {
        name = `${name.slice(0, at)} ${name.slice(at + piece.length)}`;
        break;
      }
    }
    name = name.replace(/\babsolu de parfum\b/gi, 'Absolu');
    NOISE.forEach((re) => {
      name = name.replace(re, ' ');
    });
    name = name.replace(/\s+/g, ' ').trim();
    if (!/\ble parfum$/i.test(name)) name = name.replace(/\s*\bparfum$/i, '');
    return name
      .replace(/\s+by$/i, '')
      .replace(/^[\s\-–,:]+|[\s\-–,:]+$/g, '')
      .trim();
  };

  const buildIndex = (items) => {
    const names = [];
    const seenNames = new Set();
    const brands = [];
    const seenBrands = new Set();
    const products = [];
    const byHandle = new Map();
    items.forEach(([title, vendor, handle, fams, available], rank) => {
      if (typeof title !== 'string') return;
      const brand = typeof vendor === 'string' ? vendor.trim() : '';
      const name = cleanName(title, brand) || title;
      const key = norm(name);
      if (typeof handle === 'string' && handle) {
        const record = {
          handle,
          name,
          key,
          brand,
          fams: Array.isArray(fams) ? fams : [],
          available: available === 1,
          rank,
        };
        products.push(record);
        byHandle.set(handle, record);
      }
      if (key && !seenNames.has(key)) {
        seenNames.add(key);
        names.push({ text: name, meta: brand, key, full: norm(`${brand} ${name}`) });
      }
      const bkey = norm(brand);
      if (bkey && !seenBrands.has(bkey)) {
        seenBrands.add(bkey);
        brands.push({ text: brand, meta: 'Marca', key: bkey, full: bkey });
      }
    });
    // Peso de cada familia: las poco comunes (Oud, Cuero…) cuentan más que las muy comunes (Amaderado…)
    const counts = new Map();
    products.forEach((item) => item.fams.forEach((f) => counts.set(f, (counts.get(f) || 0) + 1)));
    const weight = new Map();
    counts.forEach((n, f) => weight.set(f, Math.log((products.length + 1) / n)));
    return { names, brands, products, byHandle, weight };
  };

  const loadIndex = () => {
    if (indexPromise) return indexPromise;
    indexPromise = (async () => {
      try {
        const cached = JSON.parse(sessionStorage.getItem(INDEX_KEY) || 'null');
        if (Array.isArray(cached) && cached.length) return buildIndex(cached);
      } catch (e) {
        /* sin caché */
      }
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const items = [];
      for (let page = 1; page <= 8; page += 1) {
        const response = await fetch(
          `${root}collections/all?sort_by=best-selling&section_id=robols-search-index&page=${page}`
        );
        if (!response.ok) break;
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const node = doc.querySelector('[data-rs-index]');
        if (!node) break;
        const data = JSON.parse(node.textContent);
        items.push(...(data.items || []));
        if (!data.next) break;
      }
      try {
        sessionStorage.setItem(INDEX_KEY, JSON.stringify(items));
      } catch (e) {
        /* sin espacio: se ignora */
      }
      return buildIndex(items);
    })().catch(() => {
      indexPromise = null;
      return null;
    });
    return indexPromise;
  };

  // Abreviaturas que la gente escribe; se buscan como el nombre completo
  const ALIASES = {
    br540: 'Baccarat Rouge 540',
    'br 540': 'Baccarat Rouge 540',
    mfk: 'Maison Francis Kurkdjian',
    pdm: 'Parfums de Marly',
    ysl: 'Yves Saint Laurent',
    jpg: 'Jean Paul Gaultier',
    lv: 'Louis Vuitton',
    tf: 'Tom Ford',
    'd g': 'Dolce & Gabbana',
    dyg: 'Dolce & Gabbana',
    bdk: 'BDK Parfums',
  };
  const expand = (query) => ALIASES[norm(query)] || '';

  const startsAtWord = (haystack, needle) => haystack.startsWith(needle) || haystack.includes(` ${needle}`);

  const localSuggestions = (index, query) => {
    const alias = expand(query);
    const q = norm(alias || query);
    if (!index || !q) return [];
    // Orden: marcas que empiezan así, perfumes que empiezan así, y luego coincidencias a media frase
    const brandsFirst = index.brands.filter((b) => b.key.startsWith(q)).slice(0, 2);
    const brandsLater = index.brands.filter((b) => !b.key.startsWith(q) && startsAtWord(b.key, q)).slice(0, 1);
    const first = [];
    const rest = [];
    index.names.forEach((item) => {
      if (item.key.startsWith(q)) first.push(item);
      else if (startsAtWord(item.key, q) || startsAtWord(item.full, q)) rest.push(item);
    });
    return [...brandsFirst, ...first, ...brandsLater, ...rest].slice(0, SUG_MAX);
  };

  // Perfumes que comparten más familias olfativas con el perfume dado (mínimo 2),
  // disponibles, sin repetir la misma fragancia y con máximo 2 por marca
  const similarTo = (index, handle, exclude) => {
    const base = index && index.byHandle.get(handle);
    if (!base || base.fams.length < 2) return [];
    const baseFams = new Set(base.fams);
    const scored = [];
    index.products.forEach((item) => {
      if (item.handle === handle || exclude.has(item.handle) || !item.available) return;
      if (item.key === base.key) return;
      const shared = item.fams.filter((f) => baseFams.has(f));
      if (shared.length < 2) return;
      const score = shared.reduce((sum, f) => sum + (index.weight.get(f) || 0), 0);
      scored.push({ item, score });
    });
    scored.sort((a, b) => b.score - a.score || a.item.rank - b.item.rank);
    const perBrand = new Map();
    const picks = [];
    scored.some(({ item }) => {
      const count = perBrand.get(item.brand) || 0;
      if (count >= 2) return false;
      perBrand.set(item.brand, count + 1);
      picks.push(item);
      return picks.length >= SIMILAR_MAX;
    });
    return picks;
  };

  const handleOf = (href) => {
    try {
      const path = new URL(href, window.location.origin).pathname;
      const at = path.indexOf('/products/');
      return at < 0 ? '' : decodeURIComponent(path.slice(at + 10).split('/')[0]);
    } catch (e) {
      return '';
    }
  };

  const fetchCard = async (handle) => {
    if (cardCache.has(handle)) return cardCache.get(handle);
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const response = await fetch(`${root}products/${encodeURIComponent(handle)}?section_id=robols-search-product`);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const card = doc.querySelector('.rs-card');
    const html = card ? card.outerHTML : '';
    cardCache.set(handle, html);
    return html;
  };

  // Bloque "También te puede gustar" (panel y página de resultados)
  const similarBlock = (base, html) => {
    const block = document.createElement('div');
    block.className = 'rs-similar';
    block.dataset.rsSimilar = '';
    const title = document.createElement('h2');
    title.className = 'rs-h';
    title.textContent = 'También te puede gustar';
    const why = document.createElement('p');
    why.className = 'rs-similar__why';
    why.textContent = 'Perfumes con familias olfativas parecidas.';
    const list = document.createElement('ul');
    list.className = 'rs-grid';
    list.setAttribute('role', 'listbox');
    list.setAttribute('aria-label', title.textContent);
    list.innerHTML = html;
    block.append(title, why, list);
    return block;
  };

  // Resalta en el nombre la parte escrita, igual que las sugerencias de Shopify
  const highlight = (target, text, query) => {
    const words = norm(query).split(' ').filter(Boolean);
    const folded = fold(text);
    const last = words[words.length - 1] || '';
    let at = -1;
    if (last && folded.startsWith(last)) at = 0;
    else if (last && folded.includes(` ${last}`)) at = folded.indexOf(` ${last}`) + 1;
    if (at < 0) {
      target.textContent = text;
      return;
    }
    const mark = document.createElement('mark');
    mark.textContent = text.slice(at, at + last.length);
    target.append(text.slice(0, at), mark, text.slice(at + last.length));
  };

  class RobolsSearch extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;

      this.dialog = this.querySelector('dialog');
      this.openBtns = Array.from(this.querySelectorAll('[data-rs-open]'));
      this.openBtn = this.openBtns[0];
      this.form = this.querySelector('[data-rs-form]');
      this.input = this.querySelector('[data-rs-input]');
      this.clearBtn = this.querySelector('[data-rs-clear]');
      this.body = this.querySelector('[data-rs-body]');
      this.idle = this.querySelector('[data-rs-idle]');
      this.results = this.querySelector('[data-rs-results]');
      this.status = this.querySelector('[data-rs-status]');
      this.recentBlock = this.querySelector('[data-rs-recent-block]');
      this.recentList = this.querySelector('[data-rs-recent]');
      this.footer = this.querySelector('[data-rs-footer]');
      this.footerLink = this.querySelector('[data-rs-footer-link]');
      this.section = this.dataset.section || 'robols-predictive-search';
      this.url = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
      this.term = '';
      this.timer = null;
      this.controller = null;
      this.activeIndex = -1;

      if (!this.dialog || !this.openBtn || !this.input) return;

      this.openBtns.forEach((btn) =>
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.opener = btn;
          this.open();
        })
      );
      this.querySelectorAll('[data-rs-close]').forEach((btn) => btn.addEventListener('click', () => this.close()));
      this.dialog.addEventListener('cancel', (e) => {
        e.preventDefault();
        this.close();
      });
      // Si el navegador cierra el panel por su cuenta, se limpia igual
      this.dialog.addEventListener('close', () => this.cleanup());
      // Tocar fuera del panel (la capa oscura o el encabezado) lo cierra
      const outside = (target) =>
        target === this.dialog || target.hasAttribute('data-rs-overlay') || target.classList.contains('rs-stage');
      this.dialog.addEventListener('mousedown', (e) => {
        this.pressedOnBackdrop = outside(e.target);
      });
      this.dialog.addEventListener('click', (e) => {
        if (outside(e.target) && this.pressedOnBackdrop !== false) {
          this.close();
          return;
        }
        this.onPanelClick(e);
      });
      this.onResize = () => {
        this.placeBelowHeader();
        this.fitToScreen();
      };
      // Si algo mueve la página mientras está abierto (por ejemplo, el teclado del
      // iPhone), el panel se recoloca para seguir cubriendo la pantalla
      this.onScroll = () => this.fitToScreen();
      // En celular: al deslizar los resultados se esconde el teclado para ver más
      this.body?.addEventListener(
        'touchmove',
        () => {
          if (document.activeElement === this.input) this.input.blur();
        },
        { passive: true }
      );
      this.input.addEventListener('input', () => this.onInput());
      this.input.addEventListener('keydown', (e) => this.onKeydown(e));
      this.clearBtn?.addEventListener('click', () => {
        this.input.value = '';
        this.onInput();
        this.input.focus();
      });
      this.form.addEventListener('submit', (e) => this.onSubmit(e));
      this.querySelector('[data-rs-recent-clear]')?.addEventListener('click', () => {
        writeRecent([]);
        this.renderRecent();
        this.input.focus();
      });

      this.onShortcut = (e) => {
        if (this.dialog.open || !this.isVisible()) return;
        const el = e.target;
        const typing = el && (el.isContentEditable || /^(input|textarea|select)$/i.test(el.tagName));
        const isSlash = e.key === '/' && !typing;
        const isCmdK = (e.metaKey || e.ctrlKey) && (e.key === 'k' || e.key === 'K');
        if (isSlash || isCmdK) {
          e.preventDefault();
          this.open();
        }
      };
      document.addEventListener('keydown', this.onShortcut);
    }

    isVisible() {
      return this.openBtns.some((btn) => btn.offsetParent !== null);
    }

    openWith(term) {
      this.input.value = term || '';
      if (this.dialog.open) this.onInput();
      else this.open();
    }

    disconnectedCallback() {
      if (this.onShortcut) document.removeEventListener('keydown', this.onShortcut);
    }

    // En celular el panel ocupa toda la pantalla. En tableta y computadora empieza justo
    // debajo del encabezado, donde esté, sin mover la página.
    placeBelowHeader() {
      if (window.matchMedia('(max-width: 749px)').matches) {
        this.dialog.style.setProperty('--rs-top', '0px');
        return;
      }
      const header = document.querySelector('.section-header');
      let top = 0;
      if (header) {
        const rect = header.getBoundingClientRect();
        // Sin redondear: el encabezado puede medir 68.5 px y redondear dejaba ver
        // una línea de la página de atrás entre el encabezado y el panel
        if (rect.bottom > 0 && rect.top > -2) top = rect.bottom;
      }
      this.dialog.style.setProperty('--rs-top', `${top}px`);
    }

    // Coloca el panel exactamente sobre lo que se ve de la página
    fitToScreen() {
      this.dialog.style.setProperty('--rs-y', `${window.scrollY}px`);
      this.dialog.style.setProperty('--rs-vh', `${window.innerHeight}px`);
    }

    open() {
      if (this.dialog.open) return;
      warm();
      this.placeBelowHeader();
      this.fitToScreen();
      window.addEventListener('resize', this.onResize);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      loadIndex().then((index) => {
        this.index = index;
        if (index && this.term && !this.results.hidden) {
          this.mergeSuggestions(this.term);
          this.complete(this.term);
        }
      });
      this.dialog.showModal();
      const root = document.documentElement;
      const scrollbar = window.innerWidth - root.clientWidth;
      root.style.setProperty('--rs-scrollbar', `${scrollbar > 0 ? scrollbar : 0}px`);
      root.classList.add('rs-locked');
      this.renderRecent();
      this.input.focus({ preventScroll: true });
      const current = this.input.value.trim();
      if (current) {
        this.input.select();
        if (this.clearBtn) this.clearBtn.hidden = false;
        if (this.results.hidden || this.term !== current) this.search(current);
      }
      // Asegura que el navegador pinte el estado inicial antes de animar
      void this.dialog.offsetHeight;
      requestAnimationFrame(() => this.dialog.setAttribute('data-state', 'open'));
    }

    close() {
      if (!this.dialog.open || this.closing) return;
      this.closing = true;
      clearTimeout(this.timer);
      this.dialog.setAttribute('data-state', 'closing');
      const finish = () => {
        if (this.dialog.open) this.dialog.close();
        this.cleanup();
        const back = this.opener && this.opener.offsetParent !== null ? this.opener : this.openBtns.find((b) => b.offsetParent !== null);
        back?.focus({ preventScroll: true });
      };
      if (reduceMotion()) finish();
      else setTimeout(finish, 180);
    }

    cleanup() {
      window.removeEventListener('resize', this.onResize);
      window.removeEventListener('scroll', this.onScroll);
      this.dialog.removeAttribute('data-state');
      document.documentElement.classList.remove('rs-locked');
      this.closing = false;
    }

    onInput() {
      const q = this.input.value.trim();
      if (this.clearBtn) this.clearBtn.hidden = this.input.value.length === 0;
      clearTimeout(this.timer);
      if (!q) {
        this.term = '';
        this.abort();
        this.showIdle();
        return;
      }
      this.timer = setTimeout(() => this.search(q), 150);
    }

    abort() {
      if (this.controller) this.controller.abort();
      this.controller = null;
      this.removeAttribute('loading');
    }

    async fetchSection(q, signal) {
      const key = q.toLowerCase();
      if (cache.has(key)) return cache.get(key);
      const params = new URLSearchParams();
      params.set('q', q);
      params.set('section_id', this.section);
      params.set('resources[type]', 'product,collection,query');
      params.set('resources[limit]', '8');
      params.set('resources[limit_scope]', 'each');
      params.set('resources[options][unavailable_products]', 'last');
      params.set('resources[options][fields]', 'title,product_type,variants.title,vendor,tag');
      const response = await fetch(`${this.url}?${params.toString()}`, { signal });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const section = doc.getElementById(`shopify-section-${this.section}`);
      const html = section ? section.innerHTML : '';
      cache.set(key, html);
      return html;
    }

    async search(q) {
      this.term = q;
      const target = expand(q) || q;
      if (cache.has(target.toLowerCase())) {
        this.render(cache.get(target.toLowerCase()), q);
        return;
      }
      this.abort();
      const controller = new AbortController();
      this.controller = controller;
      this.setAttribute('loading', '');
      try {
        const html = await this.fetchSection(target, controller.signal);
        if (this.term === q) this.render(html, q);
      } catch (error) {
        if (error.name === 'AbortError') return;
        if (this.term === q) this.removeAttribute('loading');
      } finally {
        if (this.controller === controller) this.controller = null;
      }
    }

    // Con pocas letras Shopify devuelve pocos perfumes: se completan con los
    // perfumes de las sugerencias (el primer resultado de cada una)
    async enrich(q) {
      const grid = this.results.querySelector('.rs-grid');
      if (!grid || !this.index || grid.children.length >= 4) return;
      const shown = () =>
        Array.from(grid.querySelectorAll('.rs-card__name')).map((n) => norm(n.textContent));
      const missing = localSuggestions(this.index, q)
        .filter((s) => s.meta !== 'Marca')
        .filter((s) => !shown().some((name) => name.startsWith(s.key)))
        .slice(0, 3);
      if (!missing.length) return;
      const pages = await Promise.all(missing.map((s) => this.fetchSection(s.text).catch(() => '')));
      if (this.term !== q || !grid.isConnected) return;
      pages.forEach((html) => {
        if (!html || grid.children.length >= 8) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const card = doc.querySelector('.rs-grid .rs-card');
        if (card && !grid.querySelector(`[id="${card.id}"]`)) {
          const node = document.importNode(card, true);
          grid.append(node);
          node.querySelectorAll('.rs-card__img').forEach(markLoaded);
        }
      });
    }

    async complete(q) {
      try {
        await this.enrich(q);
        if (this.term === q) await this.addSimilar(q);
      } catch (e) {
        /* los extras son opcionales */
      }
    }

    // Con menos de 4 resultados, agrega perfumes con familias olfativas parecidas
    async addSimilar(q) {
      const main = this.results.querySelector('.rs-main');
      const grid = main && main.querySelector('.rs-grid');
      if (!grid || !this.index || main.querySelector('[data-rs-similar]')) return;

      if (grid.children.length >= 4) return;
      const links = Array.from(grid.querySelectorAll('.rs-card__link'));
      const handle = links.length ? handleOf(links[0].href) : '';
      const base = this.index.byHandle.get(handle);
      if (!base) return;
      const exclude = new Set(links.map((a) => handleOf(a.href)));
      const picks = similarTo(this.index, handle, exclude);
      if (!picks.length) return;
      const extra = await Promise.all(picks.map((p) => fetchCard(p.handle).catch(() => '')));
      if (this.term !== q || !main.isConnected || main.querySelector('[data-rs-similar]')) return;
      const html = extra.filter(Boolean).join('');
      if (!html) return;

      const block = similarBlock(base, html);
      main.append(block);
      block.querySelectorAll('.rs-card__img').forEach(markLoaded);
    }

    render(html, q) {
      this.removeAttribute('loading');
      this.results.innerHTML = html;
      this.results.querySelectorAll('.rs-card__img').forEach(markLoaded);
      this.results.hidden = false;
      this.idle.hidden = true;
      this.input.setAttribute('aria-expanded', 'true');
      this.mergeSuggestions(q);
      this.complete(q);
      this.updateFooter();
      this.resetActive();
      if (this.body) this.body.scrollTop = 0;
      const count = this.results.querySelectorAll('.rs-grid .rs-card').length;
      const payload = this.results.querySelector('[data-rs-payload]');
      const found = payload ? Number(payload.dataset.count || 0) : count;
      this.status.textContent = found > 0 ? `${found} perfumes para ${q}` : `Sin perfumes para ${q}`;
    }

    mergeSuggestions(q) {
      const aside = this.results.querySelector('[data-rs-aside]');
      if (!aside || !this.index) return;
      const local = localSuggestions(this.index, q);
      if (!local.length) return;

      let block = aside.querySelector('[data-rs-sug]');
      const fromShopify = block ? Array.from(block.querySelectorAll('li')) : [];
      if (!block) {
        block = document.createElement('section');
        block.className = 'rs-block rs-block--sug';
        block.dataset.rsSug = '';
        const title = document.createElement('h2');
        title.className = 'rs-h';
        title.textContent = 'Sugerencias';
        const list = document.createElement('ul');
        list.className = 'rs-list';
        list.setAttribute('role', 'listbox');
        list.setAttribute('aria-label', 'Sugerencias');
        block.append(title, list);
        aside.prepend(block);
      }
      const list = block.querySelector('ul');
      // Una sugerencia de Shopify sobra si ya está contenida en una local
      const redundant = (term) => local.some((item) => item.key.startsWith(term) || item.full.includes(term));
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const items = local.map((item, i) => {
        const li = document.createElement('li');
        li.setAttribute('role', 'option');
        li.dataset.rsOption = '';
        li.id = `${this.dialog.id}-sug-${i}`;
        const a = document.createElement('a');
        a.className = 'rs-list__link';
        a.tabIndex = -1;
        a.href = `${root}search?q=${encodeURIComponent(item.text)}&options%5Bprefix%5D=last`;
        a.dataset.rsTerm = item.text;
        const label = document.createElement('span');
        label.className = 'rs-list__text';
        highlight(label, item.text, q);
        a.append(label);
        if (item.meta) {
          const meta = document.createElement('span');
          meta.className = 'rs-list__meta';
          meta.textContent = item.meta;
          a.append(meta);
        }
        li.append(a);
        return li;
      });
      fromShopify.forEach((li) => {
        const term = li.querySelector('[data-rs-term]');
        if (term && !redundant(norm(term.dataset.rsTerm))) items.push(li);
      });
      list.replaceChildren(...items.slice(0, SUG_MAX));
    }

    // Celular: "Ver todos los resultados" fijo abajo del panel
    updateFooter() {
      if (!this.footer || !this.footerLink) return;
      const all = this.results.hidden ? null : this.results.querySelector('[data-rs-all]');
      if (all) this.footerLink.href = all.href;
      this.footer.hidden = !all;
    }

    showIdle() {
      this.results.hidden = true;
      this.results.innerHTML = '';
      this.idle.hidden = false;
      if (this.footer) this.footer.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
      this.resetActive();
      this.renderRecent();
    }

    /* Navegación con teclado */
    options() {
      const scope = this.results.hidden ? this.idle : this.results;
      return Array.from(scope.querySelectorAll('[data-rs-option]')).filter((el) => el.offsetParent !== null);
    }

    resetActive() {
      this.activeIndex = -1;
      this.querySelectorAll('[data-rs-option][data-active]').forEach((el) => el.removeAttribute('data-active'));
      this.input.removeAttribute('aria-activedescendant');
    }

    onKeydown(event) {
      const { key } = event;
      if (key === 'Escape') {
        event.preventDefault();
        this.close();
        return;
      }
      if (key !== 'ArrowDown' && key !== 'ArrowUp' && key !== 'Enter') return;
      const opts = this.options();

      if (key === 'Enter') {
        const current = opts[this.activeIndex];
        if (!current) return;
        event.preventDefault();
        const target = current.matches('a, button') ? current : current.querySelector('a, button');
        target?.click();
        return;
      }

      if (!opts.length) return;
      event.preventDefault();
      if (key === 'ArrowDown') this.activeIndex = (this.activeIndex + 1) % opts.length;
      else this.activeIndex = this.activeIndex <= 0 ? opts.length - 1 : this.activeIndex - 1;

      opts.forEach((el, i) => el.toggleAttribute('data-active', i === this.activeIndex));
      const current = opts[this.activeIndex];
      if (current.id) this.input.setAttribute('aria-activedescendant', current.id);
      current.scrollIntoView({ block: 'nearest', behavior: reduceMotion() ? 'auto' : 'smooth' });
    }

    onSubmit(event) {
      const q = this.input.value.trim();
      if (!q) {
        event.preventDefault();
        return;
      }
      this.saveRecent(q);
    }

    onPanelClick(event) {
      const removeBtn = event.target.closest('[data-rs-recent-remove]');
      if (removeBtn) {
        event.preventDefault();
        const term = removeBtn.dataset.rsRecentRemove;
        writeRecent(readRecent().filter((t) => t.toLowerCase() !== term.toLowerCase()));
        this.renderRecent();
        this.input.focus();
        return;
      }

      const termEl = event.target.closest('[data-rs-term]');
      if (termEl) {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) return;
        event.preventDefault();
        const term = termEl.dataset.rsTerm;
        this.input.value = term;
        if (this.clearBtn) this.clearBtn.hidden = false;
        this.saveRecent(term);
        clearTimeout(this.timer);
        this.search(term);
        this.input.focus({ preventScroll: true });
        return;
      }

      const link = event.target.closest('a[href]');
      if (link && !link.closest('[data-rs-idle] .rs-block--recent')) {
        const q = this.input.value.trim();
        if (q) this.saveRecent(q);
      }
    }

    /* Búsquedas recientes (se guardan solo en este dispositivo) */
    saveRecent(term) {
      const clean = term.trim().slice(0, 60);
      if (clean.length < 2) return;
      const list = readRecent().filter((t) => t.toLowerCase() !== clean.toLowerCase());
      list.unshift(clean);
      writeRecent(list.slice(0, RECENT_MAX));
    }

    renderRecent() {
      if (!this.recentList || !this.recentBlock) return;
      const list = readRecent();
      this.recentList.textContent = '';
      list.forEach((term, i) => {
        const li = document.createElement('li');
        li.className = 'rs-recent';
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'rs-chip rs-chip--recent';
        btn.dataset.rsTerm = term;
        btn.dataset.rsOption = '';
        btn.id = `${this.dialog.id}-recent-${i}`;
        btn.textContent = term;
        const rm = document.createElement('button');
        rm.type = 'button';
        rm.className = 'rs-recent__remove';
        rm.dataset.rsRecentRemove = term;
        rm.setAttribute('aria-label', `Quitar ${term} de tus búsquedas`);
        rm.textContent = '×';
        li.append(btn, rm);
        this.recentList.append(li);
      });
      this.recentBlock.hidden = list.length === 0;
    }
  }

  customElements.define('robols-search', RobolsSearch);

  // Página de resultados: "También te puede gustar" cuando hay pocos perfumes
  class RobolsSimilar extends HTMLElement {
    async connectedCallback() {
      if (this.started) return;
      this.started = true;
      const handle = this.dataset.handle;
      const exclude = new Set((this.dataset.exclude || '').split(',').filter(Boolean));
      const index = await loadIndex();
      const base = index && index.byHandle.get(handle);
      if (!base) return;
      const picks = similarTo(index, handle, exclude);
      if (!picks.length) return;
      const cards = await Promise.all(picks.map((p) => fetchCard(p.handle).catch(() => '')));
      const html = cards.filter(Boolean).join('');
      if (html) {
        this.replaceChildren(similarBlock(base, html));
        this.querySelectorAll('.rs-card__img').forEach(markLoaded);
      }
    }
  }
  if (!customElements.get('robols-similar')) customElements.define('robols-similar', RobolsSimilar);

  // Fuera del inicio, "Lo más vendido" del panel llega en cuanto la persona se acerca a buscar
  const TOP_KEY = 'robols:mas-vendido-v1';
  const loadTop = async () => {
    const blocks = Array.from(document.querySelectorAll('robols-search [data-rs-top][hidden]'));
    if (!blocks.length) return;
    let html = '';
    try {
      html = sessionStorage.getItem(TOP_KEY) || '';
    } catch (e) {
      /* sin caché */
    }
    if (!html) {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const response = await fetch(`${root}?section_id=robols-search-top`);
      if (!response.ok) return;
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const grid = doc.querySelector('[data-rs-top-grid]');
      html = grid ? grid.outerHTML : '';
      try {
        if (html) sessionStorage.setItem(TOP_KEY, html);
      } catch (e) {
        /* sin espacio */
      }
    }
    if (!html) return;
    blocks.forEach((block) => {
      if (block.querySelector('[data-rs-top-grid]')) return;
      block.insertAdjacentHTML('beforeend', html);
      block.querySelectorAll('.rs-card__img').forEach((img) => {
        img.loading = 'eager';
        markLoaded(img);
      });
      block.hidden = false;
    });
  };

  // En cuanto la persona se acerca a buscar, se adelantan las fotos del panel y el índice
  let warmed = false;
  const warm = () => {
    if (warmed) return;
    warmed = true;
    document.querySelectorAll('robols-search .rs-idle img[loading="lazy"]').forEach((img) => {
      img.loading = 'eager';
    });
    loadTop().catch(() => {});
    loadIndex();
  };
  ['pointerover', 'pointerdown', 'touchstart', 'focusin'].forEach((type) =>
    document.addEventListener(
      type,
      (e) => {
        if (e.target instanceof Element && e.target.closest('[data-rs-open], [data-rs-mbar-open], [data-rs-page-input]')) warm();
      },
      { passive: true, capture: true }
    )
  );

  // Barra de búsqueda en celular y tableta: se va al bajar y entonces aparece la lupa
  // (el estado vive en el propio buscador y no en <html>: cambiar una clase de <html>
  // obliga a recalcular los estilos de toda la página a media animación)
  const mbar = document.querySelector('[data-rs-mbar]');
  const searches = Array.from(document.querySelectorAll('robols-search'));
  const setMbar = (visible) => searches.forEach((el) => el.toggleAttribute('data-mbar-visible', visible));
  if (mbar) {
    if ('IntersectionObserver' in window) {
      const header = document.querySelector('.section-header');
      const offset = header ? Math.round(header.getBoundingClientRect().height) : 0;
      new IntersectionObserver(([entry]) => setMbar(entry.isIntersecting), {
        rootMargin: `-${offset}px 0px 0px 0px`,
      }).observe(mbar);
    } else {
      setMbar(false);
    }
  } else {
    setMbar(false);
  }
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-rs-mbar-open]');
    if (!trigger || !window.robolsSearchOpen) return;
    e.preventDefault();
    window.robolsSearchOpen('');
  });

  // Abre el panel visible con un texto (lo usa la página de resultados)
  window.robolsSearchOpen = (term) => {
    const all = Array.from(document.querySelectorAll('robols-search'));
    const target = all.find((el) => el.isVisible && el.isVisible()) || all[0];
    if (!target || !target.openWith) return false;
    target.openWith(term);
    return true;
  };
})();
